/**
 * @file m站 意见反馈
 */

import React, {Component} from 'react';
import {NavBar, Toast, Button, WingBlank, TextareaItem, InputItem, Icon} from 'antd-mobile';
import NavBarComponent from '../../../component/common/NavBarComponent'
import {Http, urls} from '../../../api/index';
import './feedBack.scss';

class HelpCenter extends Component {
    constructor() {
        super();
        this.state = {
            submit: true,
            subtype: 'warning',
            suggestinfo: '',
            cellinfo: '',
            infoL: 0,
            cellL: 0
        };
    }

    onChange(e) {
        this.setState({
          infoL: e.length,
          suggestinfo: e
        })
        this.setInfo();
    }

    onChangeCell(e) {
        this.setState({
            cellL: e.length,
            cellinfo: e
        })
        this.setInfo();
    }

    setInfo() {
        this.setState({
            submit: this.state.infoL > 0 && this.state.cellL > 0 ? false : true,
            subtype: this.state.infoL > 0 && this.state.cellL > 0 ? 'primary' : 'warning',
        })
    }

    submitinfo() {
        if (!(/^1[3456789]\d{9}$/.test(this.state.cellinfo))) {
            Toast.info('请输入正确的手机号~');
            return false;
        }
        let url = urls.feedback;
        let data = {
            comment: this.state.suggestinfo,
            contact: this.state.cellinfo,
        };
        Http.post({ url, data }).then(res => {
            Toast.success(res.msg, 3, () => {
                const {history} = this.props
                history.go(-1);
            });
        })
    }

    render() {
        return (
            <div id="feedBack" className="page">
                <NavBarComponent>
                    <NavBar icon={<Icon type="left" color='#333' />} 
                    onLeftClick={() => {this.props.history.goBack()}} mode='light'>意见反馈</NavBar>
                </NavBarComponent>
                <WingBlank>
                    <div className="page-section">
                        <div className="page-section-demo">
                            <TextareaItem className="bordere borderradios" value={this.state.suggestinfo} style={{height: '20vh'}} onChange={(e) => {this.onChange(e)}} placeholder="感谢您使用首汽租车，使用过程中有说明意见或建议请尽快联系我们" maxLength="150"/>
                        </div>
                    </div>
                    <div className="page-section">
                        <div className="page-section-demo df">
                            <div>联系方式</div>
                            <InputItem className="input bb" data-type="phone" type="number" maxLength="11" value={this.state.cellinfo} onChange={(e) => {this.onChangeCell(e)}} placeholder="" />
                        </div>
                    </div>
                    <div className="page-section">
                        <Button className="borderradios" disabled={this.state.submit}  type={this.state.subtype} onClick={(e)=>{this.submitinfo(e)}}>提交反馈</Button>
                    </div>
                </WingBlank>
            </div>
        );
    }
}

export default HelpCenter;
